import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { login, reset } from "../features/auth/authSlice";
import { toast } from "react-toastify";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { user, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  );
  const { email, password } = formData;
  // check state
  useEffect(() => {
    if (isError) {
      // server error
      if (message.includes(404))
        toast.error("Something went wrong, please try again");
      return;
    }
    if (isSuccess && user) {
      // redirect
      navigate("/dashboard");
    }
    dispatch(reset());
  }, [isError, isSuccess, user, message, navigate, dispatch]);

  const onChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const userData = {
      email,
      password,
    };
    // login into server
    dispatch(login(userData));
  };

  return (
    <div className="index">
      <div className="h-screen">
        <div className="h-full">
          <div className="flex items-center justify-between h-screen g-6 w-full">
            <div className="left w-full md:w-12/12 lg:w-6/12 py-5 md:py-5 md:mb-0 relative hidden md:block h-full">
              <div className="overlay"></div>
              <div className="flex items-center justify-center w-full h-full">
                {/* <!-- <span class="text-white text-xl md:text-3xl lg:text-5xl mr-1">Pay by</span>h-10 md:h-12 lg:h-14 --> */}
                <img
                  src="images/Logo (2)-white.png"
                  alt="Logo"
                  className="h-10 md:h-12 lg:h-14 flex items-center justify-center relative text-center mx-auto"
                />
              </div>
            </div>
            <div className="w-full md:w-12/12 lg:w-6/12 bg-white flex items-start justify-center h-full px-2 md:px-[80px] lg:px-[100px] pt-[50px] overflow-y-auto">
              <div className="p-[30px] w-full">
                <div className="mb-10 text-center">
                  <h2 className="text-4xl font-semibold text-gray-700 capitalize mb-3 text-center">
                    Welcome Back
                  </h2>
                  <p className="mt-3 text-gray-500">
                    Please sign in to your account
                  </p>
                </div>
                <form onSubmit={onSubmit}>
                  <div className="grid grid-cols-1 gap-8 mt-4 sm:grid-cols-1">
                    <div>
                      <label
                        className="text-gray-700 font-bolder mb-3"
                        htmlFor="email"
                      >
                        Email Address
                      </label>
                      <input
                        id="email"
                        type="email"
                        placeholder="Enter your email address"
                        className="block w-full h-[50px] px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring"
                        name="email"
                        min="3"
                        autoComplete="off"
                        value={email}
                        onChange={onChange}
                        required
                      />
                    </div>
                    <div>
                      <div className="flex items-center justify-between mb-3">
                        <label className="text-gray-700" htmlFor="password">
                          Password
                        </label>
                      </div>

                      <div className="rounded-md flex items-center justify-center border border-gray-300 h-[50px]">
                        <input
                          id="password"
                          type="password"
                          className="block w-full h-full px-4 py-2 text-gray-700 border-0 rounded-md focus:outline-none focus:ring-blue-300 focus:ring-opacity-40 focus:outline-none"
                          name="password"
                          autoComplete="off"
                          placeholder="Mininum of 8 characters"
                          value={password}
                          onChange={onChange}
                          required
                        />

                        <button
                          className="px-6 py-2 leading-5 text-md text-white transition-colors duration-200 transform rounded-sm focus:outline-none h-full border-0"
                          id="show-password"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                              stroke="#9998A9"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                              stroke="#9998A9"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-end my-7">
                    {/* check the href below */}
                    <Link
                      to="/fogot-password"
                      className="text-xs text-gray-600 hover:underline"
                    >
                      Forgot your Password?
                    </Link>
                  </div>
                  <div className="flex justify-center items-center mt-6">
                    <button className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-secondary rounded-md hover:bg-secondary/90 focus:outline-none focus:bg-gray-600 w-full h-[50px]">
                      Continue
                    </button>
                  </div>
                  <div className="flex items-center justify-center mt-7">
                    <div className="inline-block">
                      <span className="">Don't have an account?</span>
                      <Link
                        to="/sign-up"
                        className="text-tertiary ml-1 underline"
                        // href="signup.html"
                      >
                        Create an account
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
